import constate from 'constate';
import React, { useState, useEffect } from 'react';

import { EMPTY_ARR, EMPTY_OBJ } from 'Services/constants/empty';
import getDisplayName from 'Services/getDisplayName';

const longPollInitialize = (callback) => {
  const isInitialised = Boolean(window.dtrum);
  if (isInitialised) {
    callback();
  } else {
    window.setTimeout(() => {
      longPollInitialize(callback);
    }, 1000);
  }
};

const useAnalytics = () => {
  const [isInitialised, setIsInitialised] = useState(false);
  const [pendingEvents, setPendingEvents] = useState(EMPTY_ARR);

  const trackEvent = (name, attributes) => {
    if (isInitialised) {
      window.dtrum.enterAction(name, null, null, JSON.stringify(attributes));
    } else {
      setPendingEvents(pendingEvents.concat({
        name,
        attributes,
      }));
    }
  };
  const identifyUser = (identifierString) => {
    if (!isInitialised) return;
    window.dtrum.identifyUser(identifierString);
  };
  const sendSessionProperties = (attributes = EMPTY_OBJ) => {
    if (!isInitialised) return;
    window.dtrum.sendSessionProperties(null, null, attributes);
  };
  const endSession = () => {
    if (!isInitialised) return;
    window.dtrum.endSession();
  };

  useEffect(() => {
    const isInitialisedCallback = () => {
      setIsInitialised(true);
      pendingEvents.forEach((event) => {
        trackEvent(event.name, event.attributes);
      });
    };
    longPollInitialize(isInitialisedCallback);
  }, []);

  return {
    trackEvent,
    endSession,
    identifyUser,
    isInitialised,
    sendSessionProperties,
  };
};

export const [AnalyticsProvider, useAnalyticsContext] = constate(useAnalytics);

const defaultHOCPropConfig = [
  'trackEvent',
];

export const withAnalyticsHOC = (config = defaultHOCPropConfig) => (WrappedComponent) => {
  const withAnalytics = (props) => {
    const analyticsContext = useAnalyticsContext();
    return (
      <WrappedComponent
        {...props}
        {...config.reduce((obj, item) => ({
          ...obj,
          [item]: analyticsContext[item],
        }), {})}
      />
    );
  };
  withAnalytics.displayName = `withAnalytics(${getDisplayName(WrappedComponent)})`;
  return withAnalytics;
};
